import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import UnProtectedLayout from 'components/layouts/UnProtectedLayout';
import { SITE } from 'config/config';
import { CONST_SITE } from 'utils/common/const';

const Football = lazy(() => import('pages/Home/Football'));
const Lottery = lazy(() => import('pages/Home/Lottery'));
const PageError = lazy(() => import('pages/Error'));
const LandingPage = lazy(() => import('pages/Home/LandingPage'));
const PrizeStructure = lazy(() => import('pages/Home/prizeStructure'));
const Esports = lazy(() => import('pages/Home/Esports'));

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<UnProtectedLayout />}>
        <Route index element={<Football />} />
        <>
          <Route path="/home-ddtt" element={<Football />} />
          <Route path="/home-ddxs" element={<Lottery />} />
          <Route path="/home-ddesports" element={<Esports />} />
        </>
      </Route>
      <Route path="*" element={<PageError />} />
    </Routes>
  );
};

export default AppRoutes;
